export default __webpack_public_path__ + "static/media/P-019.79cda5b0.png";